import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  deleteCountryCoefxById,
  getCountryCoefxList,
  createCountryCoefx,
  updateCountryCoefxById,
} from "./queries";

const CountryCoefxContext = createContext({});

export const useCountryCoefxContext = () => useContext(CountryCoefxContext);

export const CountryCoefxProvider = ({ ...props }) => {
  const [countryCoefxList, setCountryCoefxList] = useState([]);
  const [countryCoefxPerId, setCountryCoefxPerId] = useState({});

  const countryCoefxListGetter = useCallback(
    async (id) => {
      try {
        if (
          countryCoefxList.length === 0 ||
          countryCoefxList[0].country_id != id
        ) {
          setCountryCoefxList(await getCountryCoefxList(id));
        }
      } catch (e) {
        console.error("countryCoefxListGetter", e);
        throw e;
      }
    },
    [countryCoefxList]
  );

  const countryCoefxDeleteById = useCallback(
    async (id) => {
      try {
        await deleteCountryCoefxById(id);
        setCountryCoefxList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("countryCoefxDeleteById", e);
        throw e;
      }
    },
    [setCountryCoefxList]
  );

  const countryCoefxCreate = useCallback(async (data) => {
    try {
      const countryCoefx = await createCountryCoefx(data);
      setCountryCoefxList((old) => [...old, countryCoefx]);
    } catch (e) {
      console.error("countryCoefxCreate", e);
      throw e;
    }
  }, []);

  const countryCoefxUpdateById = useCallback(async (id, data) => {
    try {
      const updatedCountryCoefx = await updateCountryCoefxById(id, data);
      setCountryCoefxList((old) =>
        old.map((elm) =>
          elm.id === updatedCountryCoefx.id ? updatedCountryCoefx : elm
        )
      );
      setCountryCoefxPerId(updatedCountryCoefx);
    } catch (e) {
      console.error("countryCoefxUpdateById", e);
      throw e;
    }
  }, []);
  const values = useMemo(
    () => ({
      countryCoefxListGetter,
      countryCoefxDeleteById,
      countryCoefxCreate,
      countryCoefxUpdateById,
      countryCoefxList,
      countryCoefxPerId,
      setCountryCoefxPerId,
    }),
    [
      countryCoefxListGetter,
      countryCoefxDeleteById,
      countryCoefxCreate,
      countryCoefxUpdateById,
      countryCoefxList,
      countryCoefxPerId,
      setCountryCoefxPerId,
    ]
  );
  return <CountryCoefxContext.Provider value={values} {...props} />;
};
